module.exports = __webpack_public_path__ + "img/3d373f6848ea65ce1bc6f62716b95c33.a3878d79.png";